import { CategoryType, COLLECTION_SLUGS, type CourseSkillLevel } from '@/lib/constants'
import { handleSupabaseSingle, supabase } from '@/lib/supabase-unified'
import { getCourseBySlug } from './courses'

export interface CollectionInfo {
  id: number
  title: string
  slug: string
  courseId: number
  courseTitle?: string
  courseSkillLevel?: CourseSkillLevel | null
  sort_orders_enabled: boolean
  summary?: string | null
  thumbnail?: string | null
  categoryType?: number
  allow_lesson_search?: boolean
  lesson_search_placeholder?: string
}

export async function getCollectionBySlugs(courseSlug: string, collectionSlug: string): Promise<CollectionInfo> {
  const course = await getCourseBySlug(courseSlug)

  // Handle special cases: "latest" and "continue"
  if (collectionSlug === COLLECTION_SLUGS.LATEST) {
    return {
      id: 0,
      title: 'Latest',
      slug: COLLECTION_SLUGS.LATEST,
      courseId: course.id,
      courseTitle: course.title,
      courseSkillLevel: course.skill_level ?? null,
      sort_orders_enabled: false,
      allow_lesson_search: course.metadata?.allow_lesson_search === true,
      lesson_search_placeholder: course.metadata?.lesson_search_placeholder,
    }
  }

  if (collectionSlug === COLLECTION_SLUGS.CONTINUE) {
    return {
      id: 0,
      title: 'Continue',
      slug: COLLECTION_SLUGS.CONTINUE,
      courseId: course.id,
      courseTitle: course.title,
      courseSkillLevel: course.skill_level ?? null,
      sort_orders_enabled: false,
      allow_lesson_search: course.metadata?.allow_lesson_search === true,
      lesson_search_placeholder: course.metadata?.lesson_search_placeholder,
    }
  }

  // Fetch category by slug
  const data = await handleSupabaseSingle<any>(
    supabase
      .from('category')
      .select('id, title, slug, course_id, sort_orders_enabled, type, summary, thumbnail')
      .eq('course_id', course.id)
      .eq('slug', collectionSlug)
      .in('type', [CategoryType.Section, CategoryType.Collection])
      .single() as any
  )
  
  return {
    id: data.id,
    title: data.title,
    slug: data.slug,
    courseId: data.course_id,
    courseTitle: course.title,
    courseSkillLevel: course.skill_level ?? null,
    sort_orders_enabled: data.sort_orders_enabled || false,
    summary: data.summary ?? null,
    thumbnail: data.thumbnail ?? null,
    categoryType: data.type,
    allow_lesson_search: course.metadata?.allow_lesson_search === true,
    lesson_search_placeholder: course.metadata?.lesson_search_placeholder,
  } as CollectionInfo
}


